export const getFormattedCount = (count: number): string => {
  return count >= 1000 ? '1000+' : count.toString();
};

export const getExpandedClassname = (expanded: boolean): string => {
  return expanded ? 'open' : '';
};
